import { type BTServiceFileUpload } from "legacyComponents/FileUploadContainer.types";

export const ALLOWED_BILL_UPLOAD_FILE_TYPES = ["gif", "png", "jpg", "jpeg", "pdf", "heic"];

export type BulkBillUploadFormActions = undefined | "upload" | "cancel";

export interface IBulkBillUploadFormValues {
    uploadedFiles: BTServiceFileUpload[];
}
